import styles from '../../assets/css/redirection.module.css';
import StepHeader from '../StepHeader';
import NextButton from '../NextButton';
import { PulseLoader } from 'react-spinners';
import { useRedirection } from './useRedirection';
import { useTranslation } from 'react-i18next';
import { DECOUPLED_REDIRECTION_PREFIX } from '../../utils/translationPagePrefix';
import { useObserving } from './useObserving';

interface DecoupledRedirectionProps {
	bankName: string;
	bankLogo: string;
}

const DecoupledRedirection = ({ bankName, bankLogo }: DecoupledRedirectionProps) => {
	const { redirectUser } = useRedirection();
	useObserving();

	const redirect = () => redirectUser();
	const { t } = useTranslation();

	const title = t(`${DECOUPLED_REDIRECTION_PREFIX}.title`, { bankName });
	const subtitle = t(`${DECOUPLED_REDIRECTION_PREFIX}.subtitle`);
	const hereText = t(`${DECOUPLED_REDIRECTION_PREFIX}.here`);
	const windowOpenErrorText = t(`${DECOUPLED_REDIRECTION_PREFIX}.window-error`);

	return (
		<div className={styles['redirecting-container']}>
			<StepHeader title={title} subtitle={subtitle} bankName={bankName} bankLogo={bankLogo} />
			<div className={styles['manual-redirection-text']}>
				<p>
					{windowOpenErrorText}{' '}
					<u onClick={redirect} id="redirection-text">
						{hereText}
					</u>
					.
				</p>
			</div>
			<NextButton
				text={
					<div className={styles['redirection-pulse-loader-container']}>
						<PulseLoader size="10" color="white" />
					</div>
				}
				onClick={() => {}}
				disabled={false}
			/>
		</div>
	);
};

export default DecoupledRedirection;
